import React from 'react';
import { Button, Dropdown } from 'antd';
import { DownCircleOutlined, InfoCircleOutlined, LockOutlined, UnlockOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

class Action extends React.Component {
    render() {
        const { row, action, modalLockUnlock } = this.props;
        const items = [];

        if (!action.update && !action.detail) {
            return "-"
        }

        if (action.detail) {
            items.push({
                key: '0',
                label: "Detail",
                icon: <InfoCircleOutlined />,
                onClick: () => {
                    this.props.history.push("/penilaian/status-nilai/detail/" + row.rombel_id)
                },
            })
        }

        if (action.update) {
            items.push({
                key: '1',
                label: row?.nilai_status_edit?.toLowerCase() === "nilai belum terkunci" ? "Kunci nilai" : "Buka nilai",
                onClick: () => {
                    modalLockUnlock(true, row)
                },
                icon: row?.nilai_status_edit?.toLowerCase() === "nilai belum terkunci" ? <LockOutlined /> : <UnlockOutlined />,
            })
        }

        return (
            <Dropdown
                trigger={['click']}
                menu={{ items }}
            >
                <Button type="primary">
                    Opsi <DownCircleOutlined style={{ fontSize: 11 }} />
                </Button>
            </Dropdown >
        );
    }
}


export default React.memo(withRouter(Action));
